/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorArticleSlider as ResolvedLabradorArticleSlider } from 'base/components/labrador/ArticleSlider';

export const LabradorArticleSlider: typeof ResolvedLabradorArticleSlider = withLabradorInstanceof((props) => {
    return <ResolvedLabradorArticleSlider {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorArticleSliderProps = PropsFromComponent<typeof LabradorArticleSlider>;
